import { render } from "./Onieland.vue?vue&type=template&id=96165050"
import script from "./Onieland.vue?vue&type=script&lang=js"
export * from "./Onieland.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__